/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ConversationalAgentInferencerPolymorphic } from './ConversationalAgentInferencerPolymorphic';
import {
  ConversationalAgentInferencerPolymorphicFromJSON,
  ConversationalAgentInferencerPolymorphicFromJSONTyped,
  ConversationalAgentInferencerPolymorphicToJSON,
} from './ConversationalAgentInferencerPolymorphic';
import type { SingleTurnChatInferencerPolymorphic } from './SingleTurnChatInferencerPolymorphic';
import {
  SingleTurnChatInferencerPolymorphicFromJSON,
  SingleTurnChatInferencerPolymorphicFromJSONTyped,
  SingleTurnChatInferencerPolymorphicToJSON,
} from './SingleTurnChatInferencerPolymorphic';
import type { VoiceAgentInferencerPolymorphic } from './VoiceAgentInferencerPolymorphic';
import {
  VoiceAgentInferencerPolymorphicFromJSON,
  VoiceAgentInferencerPolymorphicFromJSONTyped,
  VoiceAgentInferencerPolymorphicToJSON,
} from './VoiceAgentInferencerPolymorphic';

/**
 * @type DatasetPipelineInferencer
 *
 * @export
 */
export type DatasetPipelineInferencer =
  | ({ taskType: 'conversational_agent' } & ConversationalAgentInferencerPolymorphic)
  | ({ taskType: 'single_turn_chat' } & SingleTurnChatInferencerPolymorphic)
  | ({ taskType: 'voice_agent' } & VoiceAgentInferencerPolymorphic);

export function DatasetPipelineInferencerFromJSON(json: any): DatasetPipelineInferencer {
  return DatasetPipelineInferencerFromJSONTyped(json, false);
}

export function DatasetPipelineInferencerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPipelineInferencer {
  if (json == null) {
    return json;
  }
  switch (json['task_type']) {
    case 'conversational_agent':
      return Object.assign({}, ConversationalAgentInferencerPolymorphicFromJSONTyped(json, true), {
        taskType: 'conversational_agent',
      } as const);
    case 'single_turn_chat':
      return Object.assign({}, SingleTurnChatInferencerPolymorphicFromJSONTyped(json, true), {
        taskType: 'single_turn_chat',
      } as const);
    case 'voice_agent':
      return Object.assign({}, VoiceAgentInferencerPolymorphicFromJSONTyped(json, true), {
        taskType: 'voice_agent',
      } as const);
    default:
      throw new Error(`No variant of DatasetPipelineInferencer exists with 'taskType=${json['taskType']}'`);
  }
}

export function DatasetPipelineInferencerToJSON(value?: DatasetPipelineInferencer | null): any {
  if (value == null) {
    return value;
  }
  switch (value['taskType']) {
    case 'conversational_agent':
      return ConversationalAgentInferencerPolymorphicToJSON(value);
    case 'single_turn_chat':
      return SingleTurnChatInferencerPolymorphicToJSON(value);
    case 'voice_agent':
      return VoiceAgentInferencerPolymorphicToJSON(value);
    default:
      throw new Error(`No variant of DatasetPipelineInferencer exists with 'taskType=${value['taskType']}'`);
  }
}
